import { Controller } from '@hotwired/stimulus'

export default class OrderConfirmationController extends Controller {
  static targets = [
    'paymentFieldSet',
    'paypalButtonContainer'
  ]

  submitTargetForm = async (targetForm, event) => {
    event.preventDefault()
    event.target.classList.add('btn-loading')
    this.disablePaymentFieldset()
    targetForm.requestSubmit()
  }

  disablePaymentFieldset = () => {
    this.paymentFieldSetTarget.setAttribute('disabled', '')

    if (!this.hasPaypalButtonContainerTarget) return

    this.paypalButtonContainerTarget.classList.add('hidden')
  }

  enablePaymentFieldset = () => {
    this.paymentFieldSetTarget.removeAttribute('disabled')

    if (!this.hasPaypalButtonContainerTarget) return

    this.paypalButtonContainerTarget.classList.remove('hidden')
  }
}
